/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';

export default function WhatsIncluded() {
    return (
        <div>
            <ul>
                <li>Plant potted with planter of choice</li>
                <li>Care instructions</li>
                <li>Care & support tips for the lifetime of your plant</li>
                <li>30-Day Guarantee</li>
            </ul>
        </div>
    );
}
